module.exports = JBrowseExports["@jbrowse/core/data_adapters/BaseAdapter"];